import { useState } from 'react';
import { Apple } from 'lucide-react';
import type { ExternalProvider } from '@/services/externalAuth';
import ExternalAuthFlow from './ExternalAuthFlow';

const choices: { provider: ExternalProvider; label: string }[] = [
  { provider: 'apple', label: 'Apple' },
  { provider: 'x', label: 'X' },
];
export default function ExternalContinueButtons({ onSuccess }: { onSuccess: () => void }) {
  const [active, setActive] = useState<ExternalProvider | null>(null);
  return <div className="space-y-2" aria-label="其他登录方式">
    {choices.map(choice => <button key={choice.provider} type="button" onClick={() => setActive(choice.provider)}
      className="flex h-12 w-full items-center justify-center gap-3 rounded-xl border border-gray-300 bg-white text-sm font-medium text-gray-800"
      style={{ border: '1px solid #DADCE0' }} aria-label={`使用 ${choice.label} 继续`}>
      <span aria-hidden="true" className="flex h-5 w-5 items-center justify-center">
        {choice.provider === 'apple' ? <Apple size={20} strokeWidth={2.2} /> :
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" focusable="false">
            <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.64 7.584H.47l8.6-9.835L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
          </svg>}
      </span>
      使用 {choice.label} 继续
    </button>)}
    {active && <ExternalAuthFlow provider={active} onClose={() => setActive(null)} onSuccess={onSuccess} />}
  </div>;
}
